import { Calendar } from 'lucide-react';
import { PERIOD_MODE } from '../utils/kpiDateFilter';

const PRESETS = [
    { key: 'all', label: 'All time' },
    { key: 'today', label: 'Today' },
    { key: 'yesterday', label: 'Yesterday' },
    { key: 'week', label: 'Last 7 days' },
    { key: 'month', label: 'This month' },
];

export default function KpiDateFilterBar({
    periodMode,
    setPeriodMode,
    month,
    setMonth,
    singleDay,
    setSingleDay,
    from,
    setFrom,
    to,
    setTo,
    activePreset,
    setActivePreset,
    applyPreset,
    label,
    compact = false,
}) {
    return (
        <div className={`ag-card ${compact ? 'p-3' : 'p-4'} space-y-3`}>
            <div className="flex flex-wrap items-center justify-between gap-2">
                <div className="flex items-center gap-2">
                    <Calendar className="h-4 w-4 text-brand-teal" />
                    <span className="text-sm font-bold text-ink-800">Date filter</span>
                    {label && (
                        <span className="text-xs text-ink-500 hidden sm:inline">· {label}</span>
                    )}
                </div>
            </div>

            <div className="flex flex-wrap gap-1.5">
                {PRESETS.map(p => (
                    <button
                        key={p.key}
                        type="button"
                        onClick={() => applyPreset(p.key)}
                        className={`px-3 py-1.5 rounded-full text-xs font-semibold border transition ${
                            activePreset === p.key
                                ? 'bg-brand-teal text-white border-brand-teal'
                                : 'bg-white text-ink-700 border-ink-200 hover:border-brand-teal'
                        }`}
                    >
                        {p.label}
                    </button>
                ))}
                <button
                    type="button"
                    onClick={() => applyPreset('day')}
                    className={`px-3 py-1.5 rounded-full text-xs font-semibold border transition ${
                        activePreset === 'day' || periodMode === PERIOD_MODE.day
                            ? 'bg-brand-teal text-white border-brand-teal'
                            : 'bg-white text-ink-700 border-ink-200 hover:border-brand-teal'
                    }`}
                >
                    Pick a date
                </button>
                <button
                    type="button"
                    onClick={() => applyPreset('range')}
                    className={`px-3 py-1.5 rounded-full text-xs font-semibold border transition ${
                        activePreset === 'range' || periodMode === PERIOD_MODE.range
                            ? 'bg-brand-teal text-white border-brand-teal'
                            : 'bg-white text-ink-700 border-ink-200 hover:border-brand-teal'
                    }`}
                >
                    Date range
                </button>
            </div>

            {periodMode === PERIOD_MODE.month && (
                <label className="space-y-1 block max-w-xs">
                    <span className="text-xs text-ink-600">Select month</span>
                    <input
                        type="month"
                        value={month}
                        onChange={e => {
                            setMonth(e.target.value);
                            setPeriodMode(PERIOD_MODE.month);
                            setActivePreset?.('month');
                        }}
                        className="ag-input w-full text-sm"
                    />
                </label>
            )}

            {periodMode === PERIOD_MODE.day && (
                <label className="space-y-1 block max-w-xs">
                    <span className="text-xs text-ink-600">Select date</span>
                    <input
                        type="date"
                        value={singleDay}
                        onChange={e => {
                            setSingleDay(e.target.value);
                            setPeriodMode(PERIOD_MODE.day);
                            setActivePreset?.('day');
                        }}
                        className="ag-input w-full text-sm"
                    />
                </label>
            )}

            {periodMode === PERIOD_MODE.range && (
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-lg">
                    <label className="space-y-1 block">
                        <span className="text-xs text-ink-600">From date</span>
                        <input
                            type="date"
                            value={from}
                            max={to || undefined}
                            onChange={e => {
                                setFrom(e.target.value);
                                setPeriodMode(PERIOD_MODE.range);
                                setActivePreset?.('range');
                            }}
                            className="ag-input w-full text-sm"
                        />
                    </label>
                    <label className="space-y-1 block">
                        <span className="text-xs text-ink-600">To date</span>
                        <input
                            type="date"
                            value={to}
                            min={from || undefined}
                            onChange={e => {
                                setTo(e.target.value);
                                setPeriodMode(PERIOD_MODE.range);
                                setActivePreset?.('range');
                            }}
                            className="ag-input w-full text-sm"
                        />
                    </label>
                </div>
            )}

            {label && (
                <p className="text-xs text-ink-500 sm:hidden">{label}</p>
            )}
        </div>
    );
}
